import styled from 'styled-components'

const StyledCards = styled.div`
    width: 1300px;
    min-height: 500px;
    display: grid;
    grid-template-columns: auto auto auto auto;
    //border: 1px solid black;
    justify-content: center;
`

export default StyledCards

